export default __webpack_public_path__ + "static/media/13473_RZ_Energy_Experience_Outdoorstelen_A11 5.b9b240ba.pdf";